import React from 'react'

import { Paper, withStyles, Typography } from '@material-ui/core'
import { FilterNone } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import NoDataDisplay from '../NoDataDisplay/NoDataDisplay'
import Spinner from '../UI/Spinner/Spinner'

const PleaseFilter = ({ translate, children, show, noData, loading }) => {
  const pleaseFilterDisplay = (
    <StyledPaper>
      <FilterNone color={'disabled'} style={{ fontSize: '3rem' }} />
      <Typography variant={'h5'} color={'textSecondary'}>
        {translate('pleaseFilter')}
      </Typography>
    </StyledPaper>
  )

  let display = pleaseFilterDisplay
  if (children) {
    if (!show) {
      display = children
      if (loading) {
        display = <Spinner />
      }
      if (noData) {
        display = <NoDataDisplay />
      }
    }
  }

  return display
}

const StyledPaper = withStyles(theme => {
  return {
    root: {
      height: 400,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }
  }
})(Paper)

export default withTranslate(PleaseFilter)
